<ngx-spinner
             bdColor="#fff"
             size="medium"
             color="#FA030E "
             type="ball-pulse"
>
</ngx-spinner>
